<script>
	// import { tick } from "svelte";
	import * as Yup from "yup";
	import { useValidations } from "../../ursCommon/Forms.svelte";
	import {FormGroup, Input, Alert, Icon, Button, Card, CardHeader, CardBody, CardText,} from "@sveltestrap/sveltestrap";
	import { dateStuff } from "../../common/Date.svelte";
	import PhysicianInput from "../../common/PractitionerInput.svelte";
	//import A1cInput, { A1CTypes } from "./A1cInput.svelte";
	import MemberInput from "../glp1/MemberInputWithA1c.svelte";
	import MedicationInput from "./MedicationInput.svelte";
	import FileUploader from "../../common/FileUploader.svelte";
	import * as MedicationInfo from "./Medications.svelte";
	import GlobalLoader, { Loader } from "../../ursCommon/GlobalLoader.svelte";
	import { baseUrl } from "../../ursCommon/Common.svelte";
	import { typeOptions } from "../../pharmacy/choices";
	import Dialog from "../../ursCommon/Dialog.svelte";
  import { onMount } from "svelte";

	const medications = MedicationInfo.Medications;
	const { validateField, validateForm, getErrors, resetErrors, removeError } =
		useValidations();
	const { getUsDateOnly } = dateStuff();
	const antiForgeryTokenName = "RequestVerificationToken";

	let submitting = $state(false);
	let sendError;
	let prompt;
	let pdfKey = $state(null);
	let memberName = $state(null);
	let memberId = $state(null);
	let medicationName = $state(null);
	let errors = $derived(getErrors());
	let formHasErrors = $state(false);
	// let requestType = $state("");
	// let hasType2Diabetes = $state();
	// let had3MonthMetforminTrial = $state();
	let hadTrialSideEffects = $state();
	let usedGradualDoseTitration = $state();
	let hasContraindication = $state();
	let hadA1CReduction = $state();
	let success = $state(null);
	const yesNo = ["Yes", "No"];
	const submissionDate = new Date();

	let physicianInput;
	let memberInfo;
	let medicationInput;
	let fileUploader;
	let baseLineA1C;
	let currentA1C;
	let files;
	//let providerInfo = $state(null);

	let formData = $state({
		requestType: "",
		hasType2Diabetes: false,
		had3MonthMetforminTrial: false,
		hadTrialSideEffects: hadTrialSideEffects,
		usedGradualDoseTitration: usedGradualDoseTitration,
		hasContraindication: hasContraindication,
		hadA1CReduction: hadA1CReduction,
	});
	let preScreenComplete = $derived(
		formData.requestType !== "" &&
			formData.hasType2Diabetes &&
			formData.had3MonthMetforminTrial,
	);
	let disabled = $derived(!preScreenComplete || submitting);

	const baseSchema = Yup.object({
		requestType: Yup.string()
			.transform((v) => (typeof v === 'string' ? v.trim() : v))
			.oneOf(typeOptions, "Please select a request type.")
			.required("Please indicate the request type."),
		hasType2Diabetes: Yup.boolean()
			.oneOf(
				[true],
				"Please confirm that the patient has an estblished diagnosis of Type 2 Diabetes",
			)
			.required("Please confirm an established Type 2 diabetes diagnosis"),
		had3MonthMetforminTrial: Yup.boolean()
			.oneOf(
				[true],
				"Please confirm that the patient failed a 3-month metformin trial with optimized dosage",
			)
			.required(
				"Please confirm a failed 3-month metformin trial with optimized dosage",
			),
		hadTrialSideEffects: Yup.string().required(
			"Please indicate if the patient had gastrointestinal side effects while taking metformin",
		),
		usedGradualDoseTitration: Yup.string().required(
			"Please indicate if gradual dose titration was used",
		),
		hasContraindication: Yup.string().required(
			"Please indicate if the patient has a contraindication to metformin",
		),
	});

	const a1cReductionSchema = Yup.object({
		hadA1CReduction: Yup.string().required(
			"Please indicate if the patient had a reduction in their A1C levels while on the requested medication",
		),
	});

	let formSchema = $derived.by(() => {
		let schema = baseSchema;
		if (formData.requestType === typeOptions[0]) {
			schema = schema.concat(a1cReductionSchema);
		}
		return schema;
	});

	//onMount(async () => {
	//	const response = await fetch(`${baseUrl}Home/GetProviderInfo`, {
	//		method: "POST",
	//		headers: {
	//			__RequestVerificationToken: document.getElementsByName(
	//				"__RequestVerificationToken",
	//			)[0].value,
	//		},
	//	});
	//	let data = {};
	//	try {
	//		data = await response.json();
	//	} catch {
	//		// TODO: do something here when non-json response
	//	}
	//	providerInfo = data?.preAuthInfo;
		
	//	if (!response.ok){
	//		// couldn't get provider info
	//	}

	//	if (!data.success){
	//		// couldn't get provider info
	//	}
	//});

	async function submitForm() {
		await validateForm(formSchema, formData);
		await physicianInput.validate();
		await memberInfo.validate();
		await medicationInput.validate();
		await fileUploader.validate();
		if (formHasErrors) {			
			submitting = false;
			return;
		}
		Loader.display();

		try {
			memberName =
				memberInfo.getValues()?.firstName +
				" " +
				memberInfo.getValues()?.lastName;
			medicationName = medicationInput.getValues()?.isOtherMedicationRequired
				? medicationInput.getValues()?.otherMedication
				: medicationInput.getValues()?.medication;
			memberId = memberInfo.getValues()?.memberId;
			const fd = new FormData();
			//fd.append("__RequestVerificationToken", "");
			fd.append("requestType", formData.requestType);
			fd.append("HasType2Diabetes", formData.hasType2Diabetes);
			fd.append("Had3MonthMetforminTrial", formData.had3MonthMetforminTrial);
			fd.append("HadTrialSideEffects", formData.hadTrialSideEffects);
			fd.append("UsedGradualDoseTitration", formData.usedGradualDoseTitration);
			fd.append("HasContraindication", formData.hasContraindication);
			if (formData.requestType == typeOptions[0]) {
				fd.append("HadA1CReduction", formData.hadA1CReduction);
			}
			fd.append(
				"PractitionerName",
				physicianInput.getValues().practitionerName,
			);
			fd.append("PractitionerNpi", physicianInput.getValues().npi);
			fd.append(
				"OfficeContactName",
				physicianInput.getValues().officeContactName,
			);
			fd.append("PhoneNumber", physicianInput.getValues().phoneNumber);
			fd.append("FaxNumber", physicianInput.getValues().faxNumber);
			fd.append("Email", physicianInput.getValues()?.email);
			//fd.append("WebId", physicianInput.getValues()?.webId);
			fd.append("MemberFirstName", memberInfo.getValues()?.firstName);
			fd.append("MemberLastName", memberInfo.getValues()?.lastName);
			fd.append(
				"MemberBirthDate",
				getUsDateOnly(memberInfo.getValues()?.birthDate),
			);
			fd.append("MemberWeight", memberInfo.getValues()?.weight);
			fd.append("MemberId", memberInfo.getValues()?.memberId);
			fd.append("BaseLineA1C", memberInfo.getValues()?.baselineA1c);
			fd.append(
				"BaselineA1cDate",
				getUsDateOnly(memberInfo.getValues()?.baselineDateTaken),
			);
			fd.append("CurrentA1C", memberInfo.getValues()?.currentA1c);
			fd.append(
				"CurrentA1cDate",
				getUsDateOnly(memberInfo.getValues()?.currentDateTaken),
			);
			fd.append("Medication", medicationInput.getValues()?.medication);
			if (medicationInput.getValues()?.isOtherMedicationRequired) {
				fd.append(
					"OtherMedicationName",
					medicationInput.getValues()?.otherMedication,
				);
			}
			fd.append("Dose", medicationInput.getValues()?.dose);
			fd.append("FormFrequency", medicationInput.getValues()?.formFrequency);
			fd.append(
				"AuthorizedFromDate",
				getUsDateOnly(medicationInput.getValues()?.beginDate),
			);
			fd.append(
				"AuthorizedToDate",
				getUsDateOnly(medicationInput.getValues()?.endDate),
			);
			var previousMeds = medicationInput
				.getValues()
				?.selectedPreviousMedications.split(", ");
			for (let med of previousMeds) {
				fd.append("PreviousGlp1Medications" + med.trim(), "Yes");
			}
			if (medicationInput.getValues()?.isOtherPriorMedicationRequired) {
				fd.append(
					"OtherPreviousMedication",
					medicationInput.getValues()?.otherPrevDrugName,
				);
			}
			console.log("");
			const selectedFiles = fileUploader.getValues();
			if (selectedFiles && selectedFiles.length > 0) {
				for (const file of selectedFiles) {
					fd.append("Attachments", file);
				}
			}

			const response = await fetch(`${baseUrl}Pharmacy/GlpAttachments`, {
				method: "POST",
				headers: {
					__RequestVerificationToken: document.getElementsByName(
						"__RequestVerificationToken",
					)[0].value,
				},
				body: fd,
			});
			let data = {};
			try {
				data = await response.json();
			} catch {
				// TODO: do something here when non-json response
			}

			pdfKey = data?.pdfKey;
			success = data?.success;

			if (!response.ok) {
				const error = `Server exception: ${response.status} ${response.statusText}`;
				console.log(error);
				throw new Error();
			}

			if (!data.success) {
				prompt.showMessage(
					"We had problems processing your preauthorization request.<br/>If you continue to experience this error, please contact PEHP at <a tel:'8013667551'>801-366-7551</a>",
					"Failure",
					() => {
						window.scrollTo(0, 0);
					},
				);
				//console.log(json.errors);
				throw new Error(data.errors);
			}

			//prompt.showMessage(
			//	"We have received your preauthorization request. Any additional supporting documentation required will be requested separately.",
			//	"Success",
			//	() => {
			//		clearAllErrors();
			//		window.history.back();
			//	},
			//);
		} catch (err) {
			sendError = "Failure receiving preauthorization request. ";
			if (err.message) sendError += err.message;
		} finally {
			Loader.hide();
			submitting = false;
		}
	}

	function handleChange(fieldName, fieldValue) {
		const vars = new Map();
		vars.set(fieldName, fieldValue);
		const data = Object.fromEntries(vars);
		for (const key in data) {
			// console.log(`${key}: ${data[key]}`);
			validateField(formSchema, key, formData);
		}
		if (fieldName === "requestType" && fieldValue !== "Reauthorization") {
			hadA1CReduction = null;
		}
	}

	function handleMedicationChange() {
		validateField(formSchema, "medication", formData);
	}

	function handleSubmit(e) {
		e.preventDefault();		
		submitting = true;
		submitForm();
	}
	function cancelUpdate() {
		window.history.back();
	}

	function clearAllErrors() {
		resetErrors();
	}

	async function downloadPdf() {
		var body = JSON.stringify(pdfKey);
		const pdfResponse = await fetch(`${baseUrl}Pharmacy/DownloadPdf`, {
			method: "POST",
			headers: {
				__RequestVerificationToken: document.getElementsByName(
					"__RequestVerificationToken",
				)[0].value,
				"Content-Type": "application/json",
			},
			body: body,
		});
		const fileName = pdfKey.split(":")[1];
		const blob = await pdfResponse.blob();
		const url = URL.createObjectURL(blob);
		const a = document.createElement("a");
		a.href = url;
		a.download = fileName;
		a.click();

		URL.revokeObjectURL(url);
	}

	$effect(() => {
		formHasErrors =
			Object.keys(errors).length ||
			physicianInput?.hasErrors() ||
			memberInfo?.hasErrors() ||
			medicationInput?.hasErrors() ||
			fileUploader?.hasErrors()
				? true
				: false;
	});
</script>

<main class="glp-background">
	<h1>GLP-1 Preauthorization</h1>
	<h2>
		{#each medications.slice(0, medications.length - 1) as medication}
			{medication.name}&nbsp;
		{/each}
	</h2>

	{#if success}
		<div
			class="bg-success-subtle text-success-emphasis p-4 mt-5 rounded-3 border"
		>
			<h3>Success</h3>
			<p>
				Thank you for your submission. This message confirms that we have
				received the Prior Authorization (PA) request listed below:
			</p>
			<ul>
				<li>Member Name: {memberName}</li>
				<li>Member ID: {memberId}</li>
				<li>Prescription Name: {medicationName}</li>
			</ul>
			<p>
				Please allow up to <strong
					>72 hours for the request to be reviewed.</strong
				> A status update (approval, denial, rejection or if additional information
				is needed) will be sent once the review is complete.
			</p>
			<a href="#" onclick={() => downloadPdf()}>Download your submission here</a
			>
		</div>
	{:else}
		<form onsubmit={handleSubmit} class="mt-5">
			<div class="bg-primary-subtle text-primary-emphasis p-4 rounded-3 border">
				<h4 class="mb-2">Preauthorization Requirements</h4>

				<p class="mb-3">
					<strong
						>A valid preauthorization request requires both of the following:</strong
					>
				</p>

				<ul class="mb-4">
					<li>
						Confirmed diagnosis of <strong>Type II Diabetes</strong>
					</li>
					<li>
						Documented failure of at least a <strong
							>3-month trial of optimized metformin therapy</strong
						>
					</li>
				</ul>

				<div class="fw-semibold">
					<i>If either condition is not met,</i>
					<strong>do not submit a preauthorization request</strong>
					<i>, as it will be denied.</i>
				</div>
			</div>

			<Card class="mt-3">
				<CardHeader>Pre-Screen Information</CardHeader>
				<CardBody>
					<CardText>
						<div class="Row">
							<div class="col-xs-12">
								<label for="requestType"
									>Please indicate the type of preauthorization request?
								</label>
								{#each typeOptions as value}
									<Input
										type="radio"
										name="requestType"
										id="requestType{value}"
										{value}
										label={value}
										bind:group={formData.requestType}
										invalid={Boolean(errors.requestType)}
										on:change={(e) =>
											handleChange("requestType", e.target.value)}
										class="ms-2"
									/>
								{/each}
								{#if Boolean(errors?.requestType)}
									<div id="requestTypeError" class="radioButtonInvalid">
										{errors.requestType}
									</div>
								{/if}
							</div>
						</div>
						<div class="row">
							<div class="col-xs-12 col-sm-12">
								<label for="hasTypeTwo"
									>Please confirm that the patient has an established diagnosis
									of <strong>Type II Diabetes.</strong></label
								>
								<br /><Input
									id="hasTypeTwo"
									name="hasTypeTwo"
									bind:checked={formData.hasType2Diabetes}
									type="checkbox"
									label="Confirm"
									class="ms-3 bold"
									disabled={formData.requestType === ""}
									invalid={Boolean(errors.hasType2Diabetes)}
									on:change={(e) =>
										handleChange("hasType2Diabetes", e.target.value)}
								/>
								{#if Boolean(errors?.hasType2Diabetes)}
									<div id="hasType2DiabetesError" class="radioButtonInvalid">
										{errors.hasType2Diabetes}
									</div>
								{/if}
							</div>
							<div class="col-xs-12 col-sm-12 p-2 m-1">
								<label for="hadMetformin"
									>Please confirm that the patient has a documented failure of
									at least a <strong
										>3-month trial of optimized metformin therapy</strong
									> (2000 mg per day).</label
								>
								<br /><Input
									id="hadMetformin"
									name="hadMetformin"
									bind:checked={formData.had3MonthMetforminTrial}
									type="checkbox"
									label="Confirm"
									class="ms-3 bold"
									disabled={formData.requestType === ""}
									invalid={Boolean(errors.had3MonthMetforminTrial)}
									on:change={(e) =>
										handleChange("had3MonthMetforminTrial", e.target.value)}
								/>
								{#if Boolean(errors?.had3MonthMetforminTrial)}
									<div
										id="had3MonthMetforminTrialError"
										class="radioButtonInvalid"
									>
										{errors.had3MonthMetforminTrial}
									</div>
								{/if}
							</div>
						</div>
						<div class="row">
							<div class="col-s-12 center">
								Please contact the PEHP Pharmacy Department with any questions
								regarding this preauthorization. <a href="tel:8013667551"
									>(801) 366-7551</a
								>.
							</div>
						</div>
					</CardText>
				</CardBody>
			</Card>

			<Card class="mt-3">
				<CardHeader>Practitioner Information</CardHeader>
				<CardBody>
					<CardText>
						<div class="row">
							<div class="col-xs-12 col-sm-12">
								<PhysicianInput bind:this={physicianInput} {disabled} />
							</div>
						</div>
					</CardText>
				</CardBody>
			</Card>

			<Card class="mt-3">
				<CardHeader>Patient Information</CardHeader>
				<CardBody>
					<CardText>
						<MemberInput bind:this={memberInfo} {disabled} />
					</CardText>
				</CardBody>
			</Card>

			<Card class="mt-3">
				<CardHeader>Medication Information</CardHeader>
				<CardBody>
					<CardText>
						<MedicationInput bind:this={medicationInput} {disabled} />
					</CardText>
				</CardBody>
			</Card>

			<Card class="mt-3">
				<CardHeader>Follow up Questions</CardHeader>
				<CardBody>
					<CardText>
						<div class="row">
							<div class="col-sm-10">
								<label for="hadTrialSideEffects"
									>Was the patient not able to complete the optimized metformin
									trial due to gastrointestinal side effects?</label
								>
								{#if Boolean(errors?.hadTrialSideEffects)}
									<div id="hadTrialSideEffectsError" class="radioButtonInvalid">
										{errors.hadTrialSideEffects}
									</div>
								{/if}
							</div>
							<div class="col-sm-2">
								<span class="required"></span>
								{#each yesNo as value}
									<Input
										type="radio"
										name="hadTrialSideEffects"
										id="hadTrialSideEffects{value}"
										{value}
										label={value}
										bind:group={formData.hadTrialSideEffects}
										invalid={Boolean(errors.hadTrialSideEffects)}
										feedback={errors.hadTrialSideEffects ? "1" : "0"}
										{disabled}
										on:change={(e) =>
											handleChange("hadTrialSideEffects", e.target.value)}
									/>
								{/each}
							</div>
						</div>
						<div class="row">
							<hr />
							<div class="col-sm-10">
								<label for="usedGradualDoseTitration"
									>Was the metformin trial conducted with a gradual dose
									titration to mitigate the side effects?</label
								>
								{#if Boolean(errors?.usedGradualDoseTitration)}
									<div
										id="usedGradualDoseTitrationError"
										class="radioButtonInvalid"
									>
										{errors.usedGradualDoseTitration}
									</div>
								{/if}
							</div>
							<div class="col-sm-2">
								{#each yesNo as value}
									<Input
										type="radio"
										name="usedGradualDoseTitration"
										id="usedGradualDoseTitration{value}"
										{value}
										label={value}
										bind:group={formData.usedGradualDoseTitration}
										invalid={Boolean(errors.usedGradualDoseTitration)}
										feedback={errors.usedGradualDoseTitration ? "1" : "0"}
										{disabled}
										on:change={(e) =>
											handleChange("usedGradualDoseTitration", e.target.value)}
									/>
								{/each}
							</div>
						</div>
						<div class="row">
							<hr />
							<div class="col-sm-10">
								<label for="hasContraindication"
									>Does the patient have a contraindication to metformin (e.g.,
									eGFR below 30 mL/min/1.73 m<sup>2</sup>, hypersensitivity)?</label
								>
								{#if Boolean(errors?.hasContraindication)}
									<div id="hasContraindicationError" class="radioButtonInvalid">
										{errors.hasContraindication}
									</div>
								{/if}
							</div>
							<div class="col-sm-2">
								{#each yesNo as value}
									<Input
										type="radio"
										name="hasContraindication"
										id="hasContraindication{value}"
										{value}
										label={value}
										bind:group={formData.hasContraindication}
										invalid={Boolean(errors.hasContraindication)}
										feedback={errors.hasContraindication ? "1" : "0"}
										{disabled}
										on:change={(e) =>
											handleChange("hasContraindication", e.target.value)}
									/>
								{/each}
							</div>
						</div>
						{#if formData.requestType == typeOptions[0]}
							<div class="row">
								<hr />
								<div class="col-sm-10">
									<label for="hadA1CReduction"
										>Has the patient realized at least a 2-point reduction from
										their baseline A1C while on this therapy?</label
									>
									{#if Boolean(errors?.hadA1CReduction)}
										<div id="hadA1CReductionError" class="radioButtonInvalid">
											{errors.hadA1CReduction}
										</div>
									{/if}
								</div>
								<div class="col-sm-2">
									{#each yesNo as value}
										<Input
											type="radio"
											name="hadA1CReduction"
											id="hadA1CReduction{value}"
											{value}
											label={value}
											bind:group={formData.hadA1CReduction}
											invalid={Boolean(errors.hadA1CReduction)}
											feedback={errors.hadA1CReduction ? "1" : "0"}
											class="check-contrast"
											{disabled}
											on:change={(e) =>
												handleChange("hadA1CReduction", e.target.value)}
										/>
									{/each}
								</div>
							</div>
						{/if}
					</CardText>
				</CardBody>
			</Card>

			<Card class="mt-3">
				<CardHeader>Upload Laboratory / Clinical Documentation</CardHeader>
				<CardBody>
					<CardText>
						<FileUploader bind:this={fileUploader} {disabled} />
					</CardText>
				</CardBody>
			</Card>

			<div class="row mb-5">
				<div class="button-group mt-3">
					<button
						type="button"
						class="btn btn-secondary btn-lg me-3"
						disabled={submitting}
						onclick={cancelUpdate}>Cancel</button
					>
					<button type="submit" class="btn btn-primary btn-lg me-3" {disabled}
						>{submitting ? 'Submitting...' : 'Request Preauthorization'}</button
					>
				</div>
			</div>
			<!-- {/if} -->
			<GlobalLoader />
		</form>
		<Dialog bind:this={prompt} />
	{/if}
</main>

<style>
</style>
